import { render, staticRenderFns } from "./AnswerAndComment.vue?vue&type=template&id=7a06e0e7"
import script from "./AnswerAndComment.vue?vue&type=script&lang=js"
export * from "./AnswerAndComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports